import {z} from "zod";

// Zod allows us to ensure that the response type meets our expectations, at runtime.
// This is better than asserting that the response type is of a certain type, because
// if the response type changes, the code will break at runtime, rather than silently.
// This gives us a better developer experience, and allows us to catch bugs earlier.

export const ArrangementAccessCheckSchema = z.object({
  songId: z.number(),
  isArrangementAccessible: z.boolean(),
});

export type ArrangementAccessCheckResponse = z.infer<typeof ArrangementAccessCheckSchema>;
